import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const areaCls = "mt-1 bg-[#F7F5F0] border-[#DCD8D0] min-h-[220px] font-mono text-sm";

// Lo que sabe el asistente de WhatsApp: las condiciones del alquiler y las notas
// prácticas de la empresa (horarios, dónde se recoge, qué incluye cada vehículo…).
export default function AssistantSettings() {
  const [s, setS] = useState(null);
  const [prompt, setPrompt] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/assistant-settings").then(({ data }) => setS(data)).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      setS((await api.put("/admin/assistant-settings", { notes: s.notes, terms: s.terms })).data);
      toast.success("Guardado");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setSaving(false);
    }
  };

  const preview = async () => {
    try {
      setPrompt((await api.get("/admin/assistant-settings/preview")).data.prompt);
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <header className="bg-white border-b border-[#DCD8D0]">
        <div className="container-x py-4">
          <Link to="/admin" className="inline-flex items-center text-[#5C5C5C] hover:text-marca"><ArrowLeft className="h-4 w-4 mr-2" /> Panel</Link>
        </div>
      </header>
      <main className="container-x py-8 max-w-4xl space-y-6">
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#1A1A1A]">Asistente de WhatsApp</h1>
        {s && (
          <>
            <p className="text-sm text-[#5C5C5C]" data-testid="as-status">
              {s.enabled
                ? "El asistente está activado: prepara borradores de respuesta con lo que escribas aquí."
                : "El asistente está desactivado en esta instalación. Lo que escribas aquí se usará cuando se active."}
            </p>
            <section className="bg-white border border-[#DCD8D0] rounded-xl p-6 space-y-4">
              <div>
                <Label htmlFor="as-terms">Condiciones del alquiler</Label>
                <Textarea id="as-terms" className={areaCls} value={s.terms} onChange={(e) => setS((d) => ({ ...d, terms: e.target.value }))} data-testid="as-terms" />
              </div>
              <div>
                <Label htmlFor="as-notes">Notas prácticas</Label>
                <Textarea id="as-notes" className={areaCls} value={s.notes} onChange={(e) => setS((d) => ({ ...d, notes: e.target.value }))} data-testid="as-notes" />
                <p className="text-xs text-[#8A8A8A] mt-1">Horarios, puntos de recogida, qué incluye cada vehículo, respuestas habituales…</p>
              </div>
              <div className="flex gap-2">
                <Button onClick={save} disabled={saving} className="bg-marca hover:bg-marca-hover text-white" data-testid="as-save">{saving ? "Guardando…" : "Guardar"}</Button>
                <Button variant="outline" onClick={preview} data-testid="as-preview">Ver instrucciones completas</Button>
              </div>
            </section>
            {prompt && (
              <pre className="bg-white border border-[#DCD8D0] rounded-xl p-6 text-xs whitespace-pre-wrap" data-testid="as-prompt">{prompt}</pre>
            )}
          </>
        )}
      </main>
    </div>
  );
}
